import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import deleteIcon from "../../Assets/Images/delete icon.png";
import sortUp from "../../Assets/Images/sortup.png";
import sortDown from "../../Assets/Images/sortdown.png";
import editIcon from "../../Assets/Images/edit icon.svg";
import { BreedsTableApi } from "../../Utils/API/BreedsTableApi";
import Pagination from "../Pagination/Pagination";
import { Modals } from "../Modals/Modals";
import EditModal from "../Modals/EditModal";
import {
  BreedListApi,
  DeleteBreedApi,
  EditPlaceholderBreedApi,
  UpdateBreednameApi,
} from "../../Utils/API/ApiCall";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";

const BreedsTable = ({ SearchValue }) => {
  const [modalShow, setModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [indexer, setIndexer] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [breedDatalist, setbreedDatalist] = useState([]);
  const [limit, setLimit] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [editIndexer, setEditIndexer] = useState();
  const [sortClick, setSortClick] = useState(1);
  const [loading, setLoading] = useState(false);
  const [breedName, setBreedName] = useState("");

  useEffect(() => {
    if (isDelete == true) {
      handleDelete(indexer);
      setModalShow(false);
      setIsDelete(false);
    }
  }, [isDelete]);

  useEffect(() => {
    setLoading(true);
    BreedListdata();
  }, [pageNumber, sortClick, SearchValue]);

  const BreedListdata = async () => {
    const data = {
      limit: 10,
      current_page: SearchValue ? 0 : pageNumber,
      sort_type: sortClick,
      column_name: "breed_name",
      search_value: SearchValue,
    };
    const Response = await BreedListApi(data);
    setLoading(false);
    setbreedDatalist(Response.data.categories);
    setLimit(Response.data.limit);
    setTotalPageCount(Response.data.total_rows);
  };

  const handleDelete = async () => {
    const data = {
      breed_cat_id: indexer,
    };
    const Response = await DeleteBreedApi(data);
    if (Response.status === 200) {
      toast.success(Response.message);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
    else if (Response.status === 400){
      toast.error(Response.message);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };

  const handleBreedname = async (payload) => {
    const data = {
      breed_cat_id: payload,
    };
    // const Response = await EditPlaceholderBreedApi(data)
  };
  const handleClickEdit = (data) => {
    console.log("data", data);
    setEditModalShow(true);
    handleBreedname(data.breed_cat_id);
    setEditIndexer(data);
  };

  const handleEditHide = () => {
    setEditModalShow(false);
    window.location.reload();
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="TableMain">
        <table>
          <thead>
            <tr>
              <th className="tablehead">
                <div className="tableheaders position-relative">
                  Breed List
                  <div className="SortButton">
                    <img
                      src={sortUp}
                      onClick={() => {
                        setSortClick(2);
                      }}
                    />
                    <img
                      src={sortDown}
                      onClick={() => {
                        setSortClick(1);
                      }}
                    />
                  </div>
                </div>
              </th>
              <th className="tablehead">
                <div className="tableheaders">Ideal Weight</div>
              </th>
              <th className="tablehead">
                <div className="tableheaders">Actions</div>
              </th>
            </tr>
          </thead>
          <tbody id="TBody">
            {breedDatalist?.length > 0 ? (
              breedDatalist.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.breed_name}</td>
                    <td>{item.ideal_weight}</td>
                    <td>
                      <div className="table-action">
                        <img
                          loading="lazy"
                          title="Delete"
                          src={deleteIcon}
                          onClick={() => {
                            setModalShow(true);
                            setIndexer(item.breed_cat_id);
                            setBreedName(item.breed_name);
                          }}
                        />
                        <img
                          loading="lazy"
                          title="Edit"
                          src={editIcon}
                          onClick={() => {
                            handleClickEdit(item);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <td className="NoDataAvailable" colSpan={2}>
                <p className="NoDataAvailable">No data available!</p>
              </td>
            )}
          </tbody>
        </table>
      </div>
      {totalPageCount > 10 ? (
        <>
          <Pagination
            Limit={limit}
            SetPageNumber={setPageNumber}
            TotalPageCount={totalPageCount}
          />
        </>
      ) : (
        <></>
      )}
      <Modals
        show={modalShow}
        onHide={() => setModalShow(false)}
        setIsDelete={setIsDelete}
        head={"Are you sure you want to delete " + breedName + "?"}
      />
      <EditModal
        show={editModalShow}
        onHide={handleEditHide}
        head="Edit the breed name"
        detail="You can edit the new breed here"
        // placeholder={breedPlaceholder}
        value={editIndexer}
        editIndexer={editIndexer}
      />
    </>
  );
};

export default BreedsTable;
